import { render } from "./P3PTemplate.vue?vue&type=template&id=6f5f6d86"
import script from "./P3PTemplate.vue?vue&type=script&lang=js"
export * from "./P3PTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__